import { types } from "mobx-state-tree"

import { PAYMENT_PROVIDERS } from "~/utilities/constants"

const UserPaymentProcessor = types
  .model("UserPaymentProcessor", {
    type: types.optional(
      types.enumeration(Object.keys(PAYMENT_PROVIDERS)),
      process.env.ENABLE_CKO_PAYMENTS === "true"
        ? PAYMENT_PROVIDERS.cko
        : process.env.ENABLE_BT_PAYMENTS === "true"
        ? PAYMENT_PROVIDERS.braintree
        : PAYMENT_PROVIDERS.stripe
    ),
    id: types.maybeNull(types.string),
  })
  .actions((self) => ({
    setType(paymentProviderType, id = "") {
      self.type = paymentProviderType
      self.id = id
    },
  }))

export default UserPaymentProcessor
